<template>
  <div
    class="charts"
    :class="{bgColorEcharts:!!serData.length}"
    :style="{'height':chartHeight +'px'}"
  >
    <!-- <v-chart v-if="serData.length" :options="options" autoresize ref="chart" id="chart_line"></v-chart>
    <div v-else class="nodata">No data was found</div>-->
    <v-chart v-if="serData.length" :options="options" autoresize ref="chart" id="chart_line"></v-chart>
    <div v-else class="nodata">No data was found</div>
  </div>
</template>

<script>
import getOption from "./barLine.config";

export default {
  props: {
    xData: {
      default: () => []
    },

    serData: {
      default: () => []
    },

    chartHeight: {
      default: 300
    }
  },

  data() {
    return {
      options: {}
    };
  },

  mounted() {
    this.options = getOption(this.xData, this.serData, []);
  },

  watch: {
    serData(newValue) {
      this.options = getOption(this.xData, newValue, []);
    }
  }
};
</script>

<style scoped>
.charts {
  width: 100%;
  /* height: 300px; */
}
.echarts {
  width: 100%;
  height: 100%;
}
.nodata {
  color: #909399;
  font-size: 14px;
  text-align: center;
  padding-top: 100px;
}
</style>